<template>
  <div class="companyEvaluationHeader ub-ac">
    <div class="header-box ub ub-ps pad-t pad-b pad-l pad-r mar-b">
      <div class="box-l">
        <div class="ft30 ft-w pad-b">{{ companyInfo.OrgName }}</div>
        <div class="ub ub-ps">
          <div class="pad-r info-l">
            <div>注册资本：{{ companyInfo.RegCapital || 0 }} 万元</div>
            <div>
              成立时间：{{ companyInfo.EstDate | formatDate('yyyy-MM-dd') }}
            </div>
            <div>联系地址：{{ companyInfo.CompanAddress }}</div>
          </div>
          <div class="pad-r info-r">
            <div>统一社会信用代码：{{ companyInfo.OrgCode }}</div>
            <div>
              在管物业项目：{{
                companyInfo.InChargeOfArea || 0
              }}
              个（其中分公司在管项目：{{
                companyInfo.SubInChargeOfArea || 0
              }}个）
            </div>
            <div>登记注册类型：{{ companyInfo.RegisteredType }}</div>
            <div>法定代表人：{{ companyInfo.LegalRep }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'companyEvaluationHeader',
  props: {
    companyInfo: Object,
  },
  data() {
    return {};
  },
};
</script>
<style lang="scss" scoped>
.companyEvaluationHeader {
  .header-box {
    box-shadow: 0px 1px 3px 0px rgba($color: #000000, $alpha: 0.1);
    .box-l {
      width: 60%;
      .info-l {
        width: 50%;
      }
    }
  }
}
</style>
